const api = require("./api");

export default function verificatePhone(phone) {
	return api(
		{
			url:     "/auth/verification",
			method:  "post",
			headers: {
				"X-TOKEN": localStorage.getItem("token") || "",
				"X-LOGIN": localStorage.getItem("login") || ""
			},
			data:    {
				phone: phone
			}
		}
	);
}
